<template>
  <div>
    <!-- Loader before showing the timesheet submission form -->
    <div v-if="!enter_ts" class="row">
      <div class="col-12">
        <order_loader :loadingMessage="'Loading Additional Payments'"></order_loader>
      </div>
    </div>

    <!-- Timesheet submission form -->
    <div v-if="enter_ts && timesheets_check">
      <ValidationObserver v-slot="{ invalid, validate }">
        <!-- Form starts here -->
        <form role="form" @submit.prevent="validateAndSubmit(validate)" class="row-form mb-3" autocomplete="off">
          <div class="timesheet-submissions">
            <div class="dates">
              <h1><i class="fas fa-calendar-alt"></i> Submitted period: {{ getWeekStarting() }}</h1>
            </div>

            <div class="timesheet_assignment mb-3">
              <div class="ts_assignment_button">
                <button class="btn orcaBtn" @click.prevent="show_ts_send_create_worker_modal()">
                  <i class="fas fa-plus"></i> Create Worker
                </button>
              </div>
              <div class="ts_assignment_explainer">
                If the worker is not in the "Select Worker", send the necessary information to create the worker.
              </div>
            </div>

            <!-- Select Worker -->
            <ValidationProvider rules="required" v-slot="{ errors, classes }" name="Select Worker" tag="div" class="form-group">
              <label class="form-label" for="selectedWorkerId">Select Worker</label>
              <multiselect
                v-model="selectedWorkerId"
                id="selectedWorkerId"
                name="selectedWorkerId"
                placeholder=""
                :options="distinctWorkersAssignments"
                :custom-label="workerLabel"
                track-by="id"
                class="requiredField"
                :class="classes"
              ></multiselect>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>

            <!-- Conditional display of tax type selection -->
            <!-- <div v-if="selectedWorkerId">
              <ValidationProvider rules="required" v-slot="{ errors, classes }" name="Select Tax Type" tag="div" class="form-group">
                <label class="form-label" for="selectedTaxType">Select Tax Type</label>
                <multiselect
                  v-model="selectedTaxType"
                  id="selectedTaxType"
                  name="selectedTaxType"
                  placeholder=""
                  :options="taxTypes"
                  :custom-label="taxTypeLabel"
                  track-by="id"
                  class="requiredField"
                  :class="classes"
                ></multiselect>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
            </div> -->

            <!-- Select Tax Description -->
            <!-- <div v-if="selectedTaxType">
              <ValidationProvider rules="required" v-slot="{ errors, classes }" name="Select Tax Desc" tag="div" class="form-group">
                <label class="form-label" for="selectedTaxDesc">Select Tax Description</label>
                <multiselect
                  v-model="selectedTaxDesc"
                  id="selectedTaxDesc"
                  name="selectedTaxDesc"
                  placeholder=""
                  :options="getAdditionalPaymentsTaxDesc(selectedTaxType.id)"
                  :custom-label="taxDescLabel"
                  track-by="id"
                  class="requiredField"
                  :class="classes"
                ></multiselect>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
            </div> -->

            <!-- Pay Amount -->
            <div v-if="selectedWorkerId">
              <ValidationProvider rules="decimal|required" v-slot="{ errors, classes }" name="Pay Amount" tag="div" class="form-group">
                <label class="form-label" for="pay_amount">Pay Amount</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">&pound;</span>
                  </div>
                  <input
                    type="decimal"
                    v-model="pay_amount"
                    id="pay_amount"
                    name="pay_amount"
                    class="form-input requiredField"
                  />
                </div>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>

              <!-- Description -->
              <ValidationProvider v-slot="{ errors, classes }" name="Description" tag="div" class="form-group">
                <label class="form-label" for="description">Description</label>
                <textarea
                  v-model="description"
                  id="description"
                  name="description"
                  class="form-input requiredField"
                ></textarea>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>

            <!-- Submit Button -->
            <div v-if="pay_amount" class="col-xl-6">
              <button :disabled="invalid" type="submit" class="btn orcaBtn w-100">
                Submit
              </button>
            </div>
          </div>
        </form>
        <!-- Form ends here -->
      </ValidationObserver>

      <!-- List of Additional Payments -->
      <b-card header="Additional Payments" header-tag="h4" body-class="mb-3 pb-2">
          <timesheet_additional_payments_datatable :type="'test'"
                          :row-data="additionalPaymentsData"
                          :loading-message="loadingMessage"
                          :no-rows-message="noRowsMessage"
                          :columns="columns"
                          :pagination-size="50"></timesheet_additional_payments_datatable>

      </b-card>
    </div>
    <div v-if="!timesheets_check">
      <div class="col-12">
        <b-card header="Error" header-tag="h4" body-class="mb-3 record_card_body">
          <div class="row">
            <div class="col-12">
              There are no timesheets to which you can add additional payments. Please submit a timesheet first, and then you will be able to add payments if necessary.
            </div>
          </div>
        </b-card>
      </div>
    </div>
    <ts_send_create_worker :company_name="this.company_name" v-if="$store.state.client_timesheets.ts_send_create_worker_modal"></ts_send_create_worker>
  </div>
</template>

<script>
import order_loader from 'loaders/order_loader';
import Multiselect from 'vue-multiselect';
import ts_send_create_worker from "pages/clients/timesheets/modals/ts_send_create_worker";
import timesheet_additional_payments_datatable from "datatables/timesheet_additional_payments_datatable";

export default {
  name: 'c_timesheet_additional_payments',
  components: {
    order_loader,
    Multiselect,
    ts_send_create_worker,
    timesheet_additional_payments_datatable,
  },
  data() {
    return {
      company_name: null,
      selected: null,
      timesheet_template_name: null,
      company_id: null,
      for_work_end_week_date: null,
      timesheet_cycle_id: null,
      submitterInitialised: true,
      enter_ts: false,
      timesheets_check: true,
      submissionWeeks: [],
      distinctWorkersAssignments: [],
      selectedWorkerId: null,
      ms_opts: {
        pre_add: [],
        post_add: [],
        pre_ded: [],
        post_ded: [],
      },
      taxTypes: [
        { id: 29, name: 'Pre-Tax Addition/Description' },
        { id: 30, name: 'Post-Tax Addition/Description' },
        { id: 31, name: 'Pre-Tax Deduction/Description' },
        { id: 32, name: 'Post-Tax Deduction/Description' },
      ],
      selectedTaxType: null,
      selectedTaxDesc: null,
      pay_amount: null,
      description: null,
      additionalPaymentsData: [], // Data for additional payments
      loadingMessage: 'Loading additional payments',
      noRowsMessage: 'No additional payments found',
      columns: [
        {headerName: 'Created at', minWidth: 150, valueGetter: this.date_created_at_getter, sort: 'desc'},
        {headerName: 'Worker', minWidth: 150, field: 'worker_name'},
        {headerName: 'Worker ref', minWidth: 150, field: 'internal_finance_ref'},
        // {headerName: 'Tax Type', minWidth: 150, field: 'tax_type'},
        // {headerName: 'Tax Description', minWidth: 150, field: 'tax_desc'},
        {headerName: 'Amount', minWidth: 100, field: 'amount'},
        {headerName: 'Description', minWidth: 250, field: 'description'},
      ]
    };
  },
  beforeMount() {
    this.fetchData();
  },
  methods: {
    date_created_at_getter(params) {
      return this.$options.filters.formatDateTimeYMD(params.data.created_at);
    },
    validateAndSubmit(validate) {
      validate().then(valid => {
        if (valid) {
          this.saving = true;

          let temp_send = {
            company_id: this.company_id,
            company_name: this.company_name,
            current_for_work_end_week_date: this.for_work_end_week_date,
            first_name: this.selectedWorkerId.first_name,
            surname: this.selectedWorkerId.surname,
            amount: this.pay_amount,
            description: this.description,
            user_name: this.$store.state.auth.me.first_name + ' ' + this.$store.state.auth.me.surname,
            internal_finance_ref: this.selectedWorkerId.internal_finance_ref,
          };

          axios.post(this.crmApiPath + 'worker/email/send_email_to_added_worker_for_additional_payment', temp_send)
          .then(() => {
            this.submitData();
          }).catch(error => {
            console.error("Error sending mail:", error);
          });
        } else {
          console.log("Form is invalid");
        }
      });
    },
    show_ts_send_create_worker_modal() {
      this.$store.commit('SHOW_SEND_CREATE_WORKER_MODAL', {
        company_id: this.company_id,
        for_work_end_week_date: this.for_work_end_week_date
      });
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'ts_send_create_worker_modal'));
    },
    getWeekStarting() {
      const start = this.$options.filters.formatDate(this.selected.start_date);
      const end = this.$options.filters.formatDate(this.selected.end_date);
      return `${start} - ${end}`;
    },
    async fetchData() {
      try {
        const companyResponse = await axios.get(`${this.crmApiPath}contact/${this.$store.state.auth.me.contact_id}/company/show`);
        const company = companyResponse.data;
        this.timesheet_template_name = company.timesheet_template_name;
        this.company_id = company.id;
        this.company_name = company.company_name;
        this.timesheet_cycle_id = company.rel_payment_process_info.timesheet_cycle_id;

        const timesheetResponse = await axios.get(`${this.crmApiPath}timesheet/historic/timesheet_periods/${company.id}`);
        const timesheetPeriods = timesheetResponse.data;

        if (timesheetPeriods.length > 0) {
          const firstPeriod = timesheetPeriods[0];
          this.for_work_end_week_date = this.$moment.utc(firstPeriod.for_work_end_week_date, 'YYYY-MM-DD').format('YYYY-MM-DD');
          this.submissionWeeks.push({
            start_date: this.$moment.utc(firstPeriod.for_work_end_week_date, 'YYYY-MM-DD').subtract(7, 'days').format('YYYY-MM-DD'),
            end_date: this.$moment.utc(firstPeriod.for_work_end_week_date, 'YYYY-MM-DD').format('YYYY-MM-DD'),
          });

          this.selected = this.submissionWeeks[0];
        } else {
          this.timesheets_check = false; // show info - no timesheets
          this.enter_ts = true; // hide loading cube
          return;
        }

        const assignmentsResponse = await axios.get(`${this.crmApiPath}assignments/company/current_assignments/${this.company_id}`);
        this.distinctWorkersAssignments = assignmentsResponse.data.distinct_workers_assignments;

        await this.fetchAdditionalPaymentOptions();

        const additionalPaymentsResponse = await axios.get(this.crmApiPath + `timesheet/additional_payments/get/${this.company_id}/${this.for_work_end_week_date}`);
        this.additionalPaymentsData = additionalPaymentsResponse.data;

        this.enter_ts = true;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    },
    async fetchAdditionalPaymentOptions() {
      this.hardCodeTypes();
        //Removed due to bug with server responses and blank drop downs
        // try {
      //   const [preAddResponse, postAddResponse, preDedResponse, postDedResponse] = await Promise.all([
      //     axios.get(this.crmApiPath + 'crm/attributes/ts_pre_tax_additions/company'),
      //     axios.get(this.crmApiPath + 'crm/attributes/ts_post_tax_additions/company'),
      //     axios.get(this.crmApiPath + 'crm/attributes/ts_pre_tax_deductions/company'),
      //     axios.get(this.crmApiPath + 'crm/attributes/ts_post_tax_deductions/company'),
      //   ]);
      //
      //   this.ms_opts.pre_add = preAddResponse.data;
      //   this.ms_opts.post_add = postAddResponse.data;
      //   this.ms_opts.pre_ded = preDedResponse.data;
      //   this.ms_opts.post_ded = postDedResponse.data;
      // } catch (error) {
      //   console.error('Error fetching payment options:', error);
      // }
    },

      hardCodeTypes(){
          this.ms_opts.pre_add = [
              {
                  "id": 107,
                  "crm_attribute_master_type_id": 29,
                  "value": "Bonus"
              },
              {
                  "id": 112,
                  "crm_attribute_master_type_id": 29,
                  "value": "Fee"
              },
              {
                  "id": 162,
                  "crm_attribute_master_type_id": 29,
                  "value": "Fuel\/Mileage"
              },
              {
                  "id": 111,
                  "crm_attribute_master_type_id": 29,
                  "value": "Loan"
              },
              {
                  "id": 170,
                  "crm_attribute_master_type_id": 29,
                  "value": "Miscellaneous"
              },
              {
                  "id": 108,
                  "crm_attribute_master_type_id": 29,
                  "value": "Overtime (Bonus)"
              },
              {
                  "id": 110,
                  "crm_attribute_master_type_id": 29,
                  "value": "Price Work"
              }
          ];
          this.ms_opts.post_add = [
              {
                  "id": 114,
                  "crm_attribute_master_type_id": 30,
                  "value": "Clothing"
              },
              {
                  "id": 116,
                  "crm_attribute_master_type_id": 30,
                  "value": "Fuel \/ Mileage"
              },
              {
                  "id": 171,
                  "crm_attribute_master_type_id": 30,
                  "value": "Miscellaneous"
              },
              {
                  "id": 136,
                  "crm_attribute_master_type_id": 30,
                  "value": "Parking"
              },
              {
                  "id": 157,
                  "crm_attribute_master_type_id": 30,
                  "value": "Subsistence"
              },
              {
                  "id": 113,
                  "crm_attribute_master_type_id": 30,
                  "value": "Tools\/Materials"
              }
          ];
          this.ms_opts.pre_ded = [
              {
                  "id": 119,
                  "crm_attribute_master_type_id": 31,
                  "value": "Loan"
              },
              {
                  "id": 172,
                  "crm_attribute_master_type_id": 31,
                  "value": "Miscellaneous"
              },
              {
                  "id": 118,
                  "crm_attribute_master_type_id": 31,
                  "value": "Over Payment"
              },
              {
                  "id": 120,
                  "crm_attribute_master_type_id": 31,
                  "value": "Van Hire"
              }
          ];
          this.ms_opts.post_ded = [
              {
                  "id": 123,
                  "crm_attribute_master_type_id": 32,
                  "value": "Clothing"
              },
              {
                  "id": 128,
                  "crm_attribute_master_type_id": 32,
                  "value": "Fines"
              },
              {
                  "id": 125,
                  "crm_attribute_master_type_id": 32,
                  "value": "Loan"
              },
              {
                  "id": 173,
                  "crm_attribute_master_type_id": 32,
                  "value": "Miscellaneous"
              },
              {
                  "id": 129,
                  "crm_attribute_master_type_id": 32,
                  "value": "Parking"
              },
              {
                  "id": 122,
                  "crm_attribute_master_type_id": 32,
                  "value": "Tools\/Materials"
              },
              {
                  "id": 121,
                  "crm_attribute_master_type_id": 32,
                  "value": "Training"
              },
              {
                  "id": 124,
                  "crm_attribute_master_type_id": 32,
                  "value": "Van Hire"
              }
          ];
      },
    // getAdditionalPaymentsTaxDesc(taxTypeId) {
    //   if (taxTypeId === 29) return this.ms_opts.pre_add;
    //   if (taxTypeId === 30) return this.ms_opts.post_add;
    //   if (taxTypeId === 31) return this.ms_opts.pre_ded;
    //   if (taxTypeId === 32) return this.ms_opts.post_ded;
    //   return [];
    // },
    workerLabel(worker) {
      return `${worker.first_name} ${worker.surname}, Ref: ${worker.internal_finance_ref}`;
    },
    // taxTypeLabel(tax) {
    //   return `${tax.name}`;
    // },
    // taxDescLabel(tax) {
    //   return `${tax.value}`;
    // },
    async refreshAdditionalPaymentsData() {
      try {
        const additionalPaymentsResponse = await axios.get(this.crmApiPath + `timesheet/additional_payments/get/${this.company_id}/${this.for_work_end_week_date}`);
        this.additionalPaymentsData = additionalPaymentsResponse.data;
      } catch (error) {
        console.error('Error refreshing additional payments data:', error);
      }
    },
    resetForm() {
      this.selectedWorkerId = null;
      this.selectedTaxType = null;
      this.selectedTaxDesc = null;
      this.pay_amount = null;
      this.description = null;
    },
    async submitData() {
      this.enter_ts = false;
      try {
        const payload = {
          // add_ded_type_id: this.selectedTaxType.id,
          // add_ded_desc_id: this.selectedTaxDesc.id,
          company_id: this.company_id,
          worker_id: this.selectedWorkerId.id,
          amount: this.pay_amount,
          description: this.description,
          for_work_end_week_date: this.for_work_end_week_date,
        };

        const response = await axios.post(this.crmApiPath + 'timesheet/additional_payments', payload);
        console.log('Data submitted successfully:', response.data);

        // Show success message
        this.$bvToast.toast('Payment submitted successfully!', {
          title: 'Success',
          variant: 'success',
          solid: true,
        });

        // Refresh the additional payments data
        await this.refreshAdditionalPaymentsData();

        // Reset formu
        this.resetForm();

      } catch (error) {
        this.enter_ts = false;
        console.error('Error submitting data:', error);
        this.$bvToast.toast('Error submitting payment. Please try again.', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        });
      } finally {
        this.enter_ts = true;
      }
    },
  }
};
</script>
